import { ApiRequestFailure } from './apiRequestFailure';

// Diagnostic serializer for the search Honeybadger reports (not user-facing) --
// keeps the raw response body verbatim for debugging, unlike the user-facing
// apiRequestFailureToMessage.
export function searchApiFailureMessage(apiError: ApiRequestFailure): string {
  // On a dropped connection (and some empty-bodied error responses) there is no
  // body to report -- responseText is '' and responseJson is null, which would
  // otherwise serialize to the uninformative literal string "null". Fall back
  // to the errorState so the report still names the failure.
  return (
    apiError.responseText ||
    (apiError.responseJson !== null
      ? JSON.stringify(apiError.responseJson)
      : apiError.errorState)
  );
}

// What a search failure is reported as. Honeybadger groups by the message, so
// the set of strings that can appear here has to stay small: a request the
// server refused, a dropped connection, or a fault in the handler that renders
// the answer. A response the schema cannot read is not among them -- a search
// boundary substitutes field by field and resolves, and reports its own
// extraction failure. See ADR 0018.
export function searchFailureMessage(error: unknown): string {
  if (error instanceof ApiRequestFailure) {
    return searchApiFailureMessage(error);
  }

  return error instanceof Error ? error.message : String(error);
}
